// Plausible Analytics helper (privacy-friendly, cookie-less).
// The base script is injected in /public/index.html.
// This module exposes helpers to fire pageviews and named events safely
// even if the script hasn't loaded yet (queue is stubbed).

export function trackPageview() {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible("pageview");
    }
  } catch {}
}

// Fire a custom event.
// - If `callback` is provided, it runs AFTER Plausible has sent the request
//   (or after a 800ms safety timeout, whichever comes first). This is the
//   recommended pattern for events immediately followed by a client-side
//   navigation, otherwise the XHR/beacon can be dropped mid-flight when
//   React unmounts the component.
export function trackEvent(name, props, callback) {
  let called = false;
  const done = () => {
    if (called) return;
    called = true;
    if (typeof callback === "function") callback();
  };
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      const opts = {};
      if (props && Object.keys(props).length > 0) opts.props = props;
      if (typeof callback === "function") opts.callback = done;
      window.plausible(name, opts);
      if (typeof callback === "function") {
        // Safety net: if Plausible is blocked (adblock, webdriver, offline)
        // the real callback never fires — make sure we don't strand the user.
        setTimeout(done, 800);
      }
      return;
    }
  } catch {}
  // Plausible unavailable — invoke the callback synchronously so the flow
  // doesn't hang.
  done();
}
